/* Timer de reserva do carrinho - Guloseimas e Companhia */
(() => {
  const KEY = 'gc_cart_reserve_start';
  const COUNT_KEY = 'gc_cart_reserve_count';
  const pad = (n) => String(n).padStart(2, '0');

  class GcCartTimer extends HTMLElement {
    static get observedAttributes() {
      return ['data-item-count'];
    }

    attributeChangedCallback() {
      if (this.isConnected) this.setup();
    }

    connectedCallback() {
      this.setup();
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    setup() {
      clearInterval(this.interval);

      this.minutes = parseFloat(this.dataset.minutes || '15');
      this.items = parseInt(this.dataset.itemCount || '0', 10);
      this.total = this.minutes * 60 * 1000;
      this.valueEl = this.querySelector('[data-gc-timer-value]');
      this.barEl = this.querySelector('[data-gc-timer-bar]');
      this.runEl = this.querySelector('[data-gc-timer-running]');
      this.overEl = this.querySelector('[data-gc-timer-expired]');

      if (!this.items) {
        this.forget();
        this.hidden = true;
        return;
      }
      this.hidden = false;

      let start = 0;
      let prev = 0;
      try {
        start = parseInt(sessionStorage.getItem(KEY) || '0', 10);
        prev = parseInt(sessionStorage.getItem(COUNT_KEY) || '0', 10);
      } catch (e) {
        /* sessionStorage indisponivel */
      }

      if (!start || Number.isNaN(start) || this.items > prev) start = Date.now();

      try {
        sessionStorage.setItem(KEY, String(start));
        sessionStorage.setItem(COUNT_KEY, String(this.items));
      } catch (e) {
        /* ignorar */
      }

      this.start = start;
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    forget() {
      try {
        sessionStorage.removeItem(KEY);
        sessionStorage.removeItem(COUNT_KEY);
      } catch (e) {
        /* ignorar */
      }
    }

    tick() {
      const left = this.total - (Date.now() - this.start);

      if (left <= 0) {
        clearInterval(this.interval);
        this.setAttribute('data-state', 'expired');
        if (this.runEl) this.runEl.hidden = true;
        if (this.overEl) this.overEl.hidden = false;
        this.style.setProperty('--gc-progress', '0%');
        return;
      }

      this.setAttribute('data-state', 'running');
      if (this.runEl) this.runEl.hidden = false;
      if (this.overEl) this.overEl.hidden = true;

      const secs = Math.ceil(left / 1000);
      if (this.valueEl) this.valueEl.textContent = pad(Math.floor(secs / 60)) + ':' + pad(secs % 60);
      this.style.setProperty('--gc-progress', ((left / this.total) * 100).toFixed(2) + '%');
    }
  }

  if (!customElements.get('gc-cart-timer')) customElements.define('gc-cart-timer', GcCartTimer);
})();
